import { render, staticRenderFns } from "./table.vue?vue&type=template&id=1becebb8&scoped=true&lang=pug&"
import script from "./table.vue?vue&type=script&setup=true&lang=js&"
export * from "./table.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./table.vue?vue&type=style&index=0&id=1becebb8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1becebb8",
  null
  
)

export default component.exports